module.exports = __webpack_public_path__ + "static/media/llanta-medicion-red.e91e8489.svg";